import * as Sentry from '@sentry/vue'

const SENTRY_DSN = window.APP_CONFIG.VITE_DSN_SENTRY
const TRACES_SAMPLE_RATE = window.APP_CONFIG.VITE_TRACES_SAMPLE_RATE
const REPLAYS_SESSION_SAMPLE_RATE = window.APP_CONFIG.VITE_REPLAYS_SESSION_SAMPLE_RATE
const REPLAYS_ON_ERROR_SAMPLE_RATE = window.APP_CONFIG.VITE_REPLAYS_ON_ERROR_SAMPLE_RATE
const SENTRY_ENVIRONMENT = window.APP_CONFIG.VITE_SENTRY_ENVIRONMENT

const initializeSentry = (app, router) => {
  if (
    SENTRY_DSN &&
    TRACES_SAMPLE_RATE &&
    REPLAYS_SESSION_SAMPLE_RATE &&
    REPLAYS_ON_ERROR_SAMPLE_RATE &&
    SENTRY_ENVIRONMENT
  ) {
    Sentry.init({
      app,
      dsn: SENTRY_DSN,
      environment: SENTRY_ENVIRONMENT,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false
        })
      ],
      tracesSampleRate: TRACES_SAMPLE_RATE,
      replaysSessionSampleRate: REPLAYS_SESSION_SAMPLE_RATE,
      replaysOnErrorSampleRate: REPLAYS_ON_ERROR_SAMPLE_RATE
    })
  }
}

export default initializeSentry
